import React, { useContext } from "react";

// plugin imports
import { Link, Trans } from "@herob191/gatsby-plugin-react-i18next";

// style imports
import "./menuRestaurant.scss";

// component imports
import { LayoutContext } from "../../../context/layoutContext";
import Separator from "../../spacers/separatorH";

// util imports
import {
	getRestaurantCartaURL,
	getRestaurantURL,
} from "../../../utils/restaurant";
import useTranslate from "../../../utils/useTranslate";

// svg imports

// component
export default function MenuRestaurant({ restaurant }) {
	const { setNavMenuOpen } = useContext(LayoutContext);

	const title = useTranslate(restaurant.frontmatter.title);
	const ctaLinks = [
		{
			link: getRestaurantCartaURL(restaurant.fields.id),
			text: <Trans>Carta</Trans>,
		},
		// {
		// 	link: getRestaurantURL(restaurant.fields.id),
		// 	text: <Trans>Ver</Trans>,
		// },
	];

	const closeMenu = () => {
		setNavMenuOpen(false);
	};

	return (
		<div>
			<Separator />
			<div className="menuRestaurant invertOnHover">
				<Link
					to={getRestaurantURL(restaurant.fields.id)}
					className="menuRestaurantLink"
					onClick={closeMenu}
				/>
				<p className="h2 padding">{title}</p>

				<div>
					<div className="ctas">
						{ctaLinks.map((cta, i) => (
							<div key={"cta" + i}>
								<div className="borderThick invertOnHover">
									<Link to={cta.link} onClick={closeMenu}>
										<span className="h3">{cta.text}</span>
									</Link>
								</div>
							</div>
						))}
					</div>
				</div>
			</div>
		</div>
	);
}
